import { I18n } from '../wrappers/I18n';
import { Settings } from '../wrappers';
import axios from 'axios';
export default class FiscalServiceWeb {
    async init(options) {
    }
    async verifyPin(pin, sdc) {
        if (sdc !== 'DEVSDC')
            return { error: this.formatError() };
        const axios = this.getAxios();
        if (!axios) {
            return { error: { code: 'not_found' } };
        }
        try {
            console.log(`${sdc} verify pin request sent`);
            const response = await axios.post('/pin', pin);
            console.log(`${sdc} verify pin response received`);
            return { data: response.data };
        }
        catch (error) {
            console.log(`${sdc} verify pin response error: ` + error.message);
            return { error: { code: 'exception' } };
        }
    }
    async createInvoice(invoice, sdc) {
        if (sdc !== 'DEVSDC')
            return { error: this.formatError() };
        const axios = this.getAxios(30000);
        if (!axios) {
            return { error: { code: 'not_found' } };
        }
        try {
            const requestId = invoice.requestId;
            delete invoice.requestId;
            console.log(`${sdc} create invoice request sent`);
            const response = await axios.post('/invoices', invoice, {
                headers: { 'RequestId': requestId },
            });
            console.log(`${sdc} create invoice response received`);
            return { data: response.data };
        }
        catch (error) {
            console.log(`${sdc} create invoice response error: ` + error.message);
            return { error: { code: 'exception' } };
        }
    }
    async getInvoice(requestId, sdc) {
        if (sdc !== 'DEVSDC')
            return { error: this.formatError() };
        const axios = this.getAxios();
        if (!axios) {
            return { error: { code: 'not_found' } };
        }
        try {
            console.log(`${sdc} get invoice request sent`);
            const response = await axios.get(`/invoices/${requestId}`);
            console.log(`${sdc} get invoice response received`);
            return { data: response.data };
        }
        catch (error) {
            console.log(`${sdc} get invoice response error: ` + error.message);
            return { error: { code: 'exception' } };
        }
    }
    async getEnvironmentParameters(sdc) {
        if (sdc !== 'DEVSDC')
            return { error: this.formatError() };
        const axios = this.getAxios();
        if (!axios) {
            return { error: { code: 'not_found' } };
        }
        try {
            console.log(`${sdc} get environment parameters request sent`);
            const response = await axios.get('/environment-parameters');
            console.log(`${sdc} get environment parameters response received`);
            return { data: response.data };
        }
        catch (error) {
            console.log(`${sdc} get environment parameters response error: ` + error.message);
            return { error: { code: 'exception' } };
        }
    }
    async getStatus(sdc) {
        if (sdc !== 'DEVSDC')
            return { error: this.formatError() };
        const axios = this.getAxios();
        if (!axios) {
            return { error: { code: 'not_found' } };
        }
        try {
            console.log(`${sdc} get status request sent`);
            const response = await axios.get('/status');
            console.log(`${sdc} get status response received`);
            return { data: response.data };
        }
        catch (error) {
            console.log(error.message);
            console.log(`${sdc} get status response error: ` + error.message);
            return { error: { code: 'exception' } };
        }
    }
    async getAttention(sdc) {
        if (sdc !== 'DEVSDC')
            return { error: this.formatError() };
        const axios = this.getAxios();
        if (!axios) {
            return { error: { code: 'not_found' } };
        }
        try {
            console.log(`${sdc} get attention request sent`);
            const response = await axios.get('/attention');
            console.log(`${sdc} get attention response received`);
            return { data: response.data };
        }
        catch (error) {
            console.log(`${sdc} get attention response error: ` + error.message);
            return { error: { code: 'exception' } };
        }
    }
    async getUiData(sdc) {
        return { error: this.formatError() };
    }
    async chooseCertificate(password, pac) {
        return { success: false };
    }
    async sendPendingAuditPackages(sdc) {
        return { error: this.formatError() };
    }
    async reset(sdc) {
        return { error: this.formatError() };
    }
    async storeLocalAuditFiles(sdc) {
        return { error: this.formatError() };
    }
    async executeCommandsFromStorage(sdc) {
        return { error: this.formatError() };
    }
    formatError() {
        return { code: 'not_possible_from_web_app', message: I18n.t('sdc.status.not_possible_from_web_app'), data: null };
    }
    getAxios(timeout = 15000) {
        // Honor the declared contract: without a configured dev-ESDC endpoint there
        // is nothing to talk to. Admin/sap define no ESDC_DEV_URL, and axios.create
        // with an undefined baseURL sent every DEVSDC request ORIGIN-RELATIVE —
        // GET /status 404-ing the app's own origin on each boot. Callers already
        // handle null (`{ error: { code: 'not_found' } }`).
        if (!Settings.env.ESDC_DEV_URL)
            return null;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        };
        return axios.create({
            baseURL: Settings.env.ESDC_DEV_URL,
            headers: headers,
            timeout: timeout
        });
    }
}
//# sourceMappingURL=FiscalServiceWeb.js.map